<template>
  <v-container fluid fill-height class="pa-0">
    <v-row no-gutters>
      <v-col cols="12">
        
        <a name="hom"></a>
        <v-row :class="$vuetify.breakpoint.smAndDown?'section secone_square':'section secone'" align="center" justify="center">
          <v-card dark class="elevation-0 transparent">
            <v-row no-gutters>
              <v-col cols="12" md="6" class="pa-0 text-md-right text-center">
                <h2>Контакты<br>Организаций<br>Москвы</h2>
              </v-col>
              <v-col cols="12" md="6" class="pa-0 pt-3 pl-4 text-md-left text-center">
                <h3>В базе {{status[0].val}} организаций</h3>
                <p class="mt-5">
                  <v-btn color="black" href="#sts">Подробнее</v-btn>
                  <v-divider class="mx-2" vertical></v-divider>
                  <a href="#dem"><b>Демо</b></a>
                </p>

              </v-col>
            </v-row>
            <p class="text-center px-6">В базе {{cont.ue}} уникальных email`ов и {{cont.up}} телефонов</p>
          </v-card>
        </v-row>

        <a name="sts"></a>
        <v-row class="betweensection font-weight-thin">
          
            <v-col cols="12" md="6" class="px-12">
              <v-row v-for="(sts,i) in status" :key="i" :class="(i % 2 == 0)?'lightrow':''">
                <v-col cols="12" sm="8" class="py-0 px-4">{{sts.key}}</v-col>
                <v-col v-if="i==0" cols="12" sm="4" class="py-4 px-4"><v-input dark messages="Организаций"><h2>{{sts.val}}</h2></v-input></v-col>
                <v-col v-if="i!=0" cols="12" sm="4" class="py-0 px-4"><b>{{sts.val}}</b></v-col>
              </v-row>
            </v-col>

            <v-col cols="12" md="6" class="px-12 text-center" align="center" justify="center">
                <v-row>
                  <v-col cols="12"><h3>Организаций (По ОГРН)</h3></v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="8" class="py-0 px-4">Московкая область</v-col>
                  <v-col cols="12" sm="4" class="py-3 px-4">{{ogrn.obl}}</v-col>
                </v-row>
                <v-row class="lightrow">
                  <v-col cols="12" sm="8" class="py-0 px-4">Город Москва</v-col>
                  <v-col cols="12" sm="4" class="py-0 px-4"><v-input dark messages="Организаций"><h2>{{ogrn.mos}}</h2></v-input></v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="8" class="py-0 px-4">Другие регионы*</v-col>
                  <v-col cols="12" sm="4" class="py-0 px-4">{{ogrn.oth}}</v-col>
                </v-row>
            </v-col>

            <v-col cols="12" md="6" class="px-12 text-center" align="center" justify="center">
                <v-row>
                  <v-col cols="12"><h3>Организаций (По адресу)</h3></v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="8" class="py-0 px-4">Московкая область</v-col>
                  <v-col cols="12" sm="4" class="py-3 px-4">{{adrs.obl}}</v-col>
                </v-row>
                <v-row class="lightrow">
                  <v-col cols="12" sm="8" class="py-0 px-4">Город Москва</v-col>
                  <v-col cols="12" sm="4" class="py-0 px-4"><v-input dark messages="Организаций"><h2>{{adrs.mos}}</h2></v-input></v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="8" class="py-0 px-4">Другие регионы*</v-col>
                  <v-col cols="12" sm="4" class="py-0 px-4">{{adrs.oth}}</v-col>
                </v-row>
            </v-col>

            <v-col cols="12" md="6" class="px-12">
                <v-row class="lightrow">
                  <v-col cols="12" sm="8" class="py-0 px-4">Уникальных email`ов в базе</v-col>
                  <v-col cols="12" sm="4" class="py-3 px-4"><v-input dark messages="Email`ов"><h2>{{cont.ue}}</h2></v-input></v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="8" class="py-0 px-4">Организаций с email`ами</v-col>
                  <v-col cols="12" sm="4" class="py-0 px-4">{{cont.e}}</v-col>
                </v-row>
                <v-row class="lightrow">
                  <v-col cols="12" sm="8" class="py-0 px-4">Организаций с телефонами</v-col>
                  <v-col cols="12" sm="4" class="py-0 px-4">{{cont.p}}</v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="8" class="py-0 px-4">Организаций с телефоном + email`ом</v-col>
                  <v-col cols="12" sm="4" class="py-0 px-4">{{cont.ep}}</v-col>
                </v-row>
                <v-row class="lightrow">
                  <v-col cols="12" sm="8" class="py-0 px-4">Организаций с 2 и более email`ами</v-col>
                  <v-col cols="12" sm="4" class="py-0 px-4">{{cont.me}}</v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="8" class="py-0 px-4">Организаций с 2 и более телефонами</v-col>
                  <v-col cols="12" sm="4" class="py-0 px-4">{{cont.mp}}</v-col>
                </v-row>
                <v-row class="lightrow">
                  <v-col cols="12" sm="8" class="py-0 px-4">Организаций с 2 и более телефонами и 2 и более email`ми</v-col>
                  <v-col cols="12" sm="4" class="py-0 px-4">{{cont.memp}}</v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="8" class="py-0 px-4">Всего email`ов в базе</v-col>
                  <v-col cols="12" sm="4" class="py-0 px-4">{{cont.ve}}</v-col>
                </v-row>
                <v-row class="lightrow">
                  <v-col cols="12" sm="8" class="py-0 px-4">Всего телефонов в базе</v-col>
                  <v-col cols="12" sm="4" class="py-0 px-4">{{cont.vp}}</v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="8" class="py-0 px-4">Уникальных телефонов в базе</v-col>
                  <v-col cols="12" sm="4" class="py-0 px-4">{{cont.up}}</v-col>
                </v-row>
            </v-col>
            <v-col cols="12" class="text-center"><span color="red">*</span> - В базу включены организации не из Московского региона, 
            т.к. они участвуют в госзакупках и предаставляют товары и услуги 
            для организаций Москвы и Области.</v-col>
        </v-row>

        <a name="faq"></a>
        <v-row :class="$vuetify.breakpoint.smAndDown?'section sectwo_square':'section sectwo'" align="center" justify="center">
          <v-col cols="12" sm="7">
            <v-card dark class="elevation-0 transparent">
              <v-expansion-panels popout dark class="pa-0">
                <v-expansion-panel v-for="(panel,i) in panels" :key="i">
                  <v-expansion-panel-header>{{panel.header}}</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    {{panel.content}}
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-card>
          </v-col>
        </v-row>

        <a name="dem"></a>
        <v-row class="pa-3 betweensection" align="center" justify="center">
          <v-col cols="12" class="text-center pa-12">
              <video class="elevation-24" width="80%" height="auto" src="../assets/mosbas.mp4" controls />
          </v-col>
        </v-row>

        <a name="prc"></a>
        <v-row :class="$vuetify.breakpoint.smAndDown?'section secthree_square':'section secthree'" align="center" justify="center">
          <v-card dark class="elevation-0 transparent">
            <v-row no-gutters>
              <v-col cols="12" md="6" class="pa-0 text-md-right text-center">
                <h2>Акция 2020</h2>
                <v-chip color="white font-weight-bold"><span style="font-size: 1.3em;">2020 руб.</span></v-chip>
              </v-col>
              <v-col cols="12" md="6" class="pa-0 pt-1 pl-4 text-md-left text-center">
                <h3>Действует до 01.01 2020 года</h3>
              </v-col>
            </v-row>
            <v-row no-gutters class="mt-3">
              <v-col cols="12" md="6" class="pa-0 text-md-right text-center">
                <h3>Бонус Плюс</h3>
              </v-col>
              <v-col cols="12" md="6" class="pa-0 pt-1 pl-4 text-md-left text-center">
                <p>Доступ к нашему новому сервису Active Base, см. ЧаВо - Почему так дешево?</p>
              </v-col>
            </v-row>
            <v-divider class="my-2" horizontal></v-divider>
            <p class="text-center px-6">
              <v-icon color="red accent-4">mdi-alert-decagram</v-icon> 
              <b>Дополнительно</b> - спецпредложение (скидка) для ИП.<br>Подробности в <a href="javascript:jivo_api.open();">чате</a> онлайн.
            </p>
            <v-divider class="my-2" horizontal></v-divider>
            <v-row no-gutters>
              <v-col cols="12" class="text-center">
                <h3> 
                  <v-badge color="red accent-4">
                    <template v-slot:badge>
                      <span class="pl-1">-7`980 р.</span>
                    </template>
                    <span>10`000 р.</span>
                  </v-badge>
                  <span class="pl-6 font-weight-bold">2020 руб.</span>
                </h3>
                <p class="mt-2">
                  1 организация = {{ ((2020*100)/(Number(ogrn.mos)+Number(ogrn.obl)+Number(ogrn.oth))).toFixed(2) }} копеек
                  <br>1 email = {{ ((2020*100)/(Number(cont.ue))).toFixed(2) }} копеек
                  <br>1 телефон = {{ ((2020*100)/(Number(cont.up))).toFixed(2) }} копеек
                </p>
              </v-col>
            </v-row>

          </v-card>
        </v-row>

      </v-col>
    </v-row>

  </v-container>
</template>

<script>
export default {
     data(){
        return {
          dialogs:{
            about: false,
            demo:false
          },
          pop:[false,true,false,false],
          panels:[{
              header:'Кому и для чего нужна база MosBase?',
              content:'База пригодится для поиска потенциальных клиентов или поставщиков для вашего бизнеса.'
            },{
              header:'Почему так дешево?',
              content:'MOSBAS вырос в новый профессиональный сервис Active Base на active-base.ru (Оф. запуск запланирован на 01.01.2020), клиентам MOSBAS будет предоставлен приоритетный доступ в новом сервисе, а MOSBAS со временем прекратит свое существование. По-этому мы решили запустить предстартовую подарочную акцию "Скидка 2020"'
            },{
              header:'Какие данные содержатся в базе?',
              content:'В базе присутствуют следующие поля: Регион(Код), Регистрация(Дата), ОГРН, ИНН, КПП, Наименование, Полное, Адрес, Эл.почта, Телефон, Контакт Ф.И.О., Изменения в ЕГРЮЛ(Дата), Статус, Уставный капитал, ОКВЭД Код, ОКВЭД Наименование, Контрактов в Госзакупках, Последние участие в Госзакупках(Дата), Email`ы, Телефоны, Актуальность(Дата)'
            },{
              header:'Как можно приобрести базу?',
              content:'Есть 2 варианта: Яндекс Деньгами и Банковской картой. Оплата осуществляется с помощью Яндекс, это гарантирует безопасность и надежность проведения платежа.'
            },{
              header:'Каковы источники данных базы MosBase?',
              content:'У нас есть специально созданные программы, которые сканируют интернет, собирают информацию об организациях, фильтруют и актуализируют данные. Все данные получены без нарушения действующего законодательства РФ из открытых источников.'
            }
          ],
          ///Export info
          cont: {
            e: "116154",
            ve: "222274",
            p: "128888",
            vp: "234547",
            ep: "113686",
            me: "43978",
            mp: "47457",
            memp: "33187",
            ue: "176921",
            up: "187886",
          },
          ogrn: {
            mos: "64322",
            obl: "20226",
            oth: "47882",
          },
          adrs: {
            mos: "59549",
            oth: "53277",
            obl: "19604",
          },
          status: [
            {key: "Действующее", val: "109184"},
            {key: "Исключено из ЕГРЮЛ", val: "2514"},
            {key: "Находится в процедуре банкротства", val: "786"},
            {key: "Находится в процессе реорганизации", val: "1162"},
            {key: "Находится в стадии ликвидации", val: "2254"},
            {key: "Прекратило деятельность", val: "15157"},
            {key: "Принято решение о предстоящем исключении из ЕГРЮЛ", val: "1317"},
            {key: "Регистрация признана недействительной по решению суда", val: "1"},
            {key: "Регистрация признана ошибочной", val: "55"},
          ]
          ///Export info end
        }
     },
     mounted(){
        this.$root.$on('openAbout', () => {
          this.dialogs.about=!this.dialogs.about
        })
        this.$root.$on('openDemo', () => {
          this.dialogs.demo=!this.dialogs.demo
        })
     }
}
</script>
<style scoped>
.betweensection {
  padding: 150px 0px 100px 0px;
  min-height: 100vh;
  color: #fff;
  box-shadow: inset 0px 0px 25px 5px rgba(0, 0, 0, 1);
  background: rgba(0,0,0,1);
  background: -moz-linear-gradient(left, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 0%, rgba(2,4,18,1) 12%, rgba(11,26,51,1) 37%, rgba(28,8,27,1) 84%, rgba(0,0,0,1) 100%);
  background: -webkit-gradient(left top, right top, color-stop(0%, rgba(0,0,0,1)), color-stop(0%, rgba(0,0,0,1)), color-stop(12%, rgba(2,4,18,1)), color-stop(37%, rgba(11,26,51,1)), color-stop(84%, rgba(28,8,27,1)), color-stop(100%, rgba(0,0,0,1)));
  background: -webkit-linear-gradient(left, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 0%, rgba(2,4,18,1) 12%, rgba(11,26,51,1) 37%, rgba(28,8,27,1) 84%, rgba(0,0,0,1) 100%);
  background: -o-linear-gradient(left, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 0%, rgba(2,4,18,1) 12%, rgba(11,26,51,1) 37%, rgba(28,8,27,1) 84%, rgba(0,0,0,1) 100%);
  background: -ms-linear-gradient(left, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 0%, rgba(2,4,18,1) 12%, rgba(11,26,51,1) 37%, rgba(28,8,27,1) 84%, rgba(0,0,0,1) 100%);
  background: linear-gradient(to right, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 0%, rgba(2,4,18,1) 12%, rgba(11,26,51,1) 37%, rgba(28,8,27,1) 84%, rgba(0,0,0,1) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#000000', endColorstr='#000000', GradientType=1 );
}
.section {
  min-height: 100vh;
}
.section:before {
  content: "";
  min-height: 100vh;
  width: 100%;
  position:absolute;
  background: url(../assets/bg-pattern.png)!important;
}
.section.secone {
  background-image: linear-gradient(rgba(0,0,0,0.2), rgba(0,0,0,1)), url(../assets/MoscowNight1_30.jpg);
  background-size: cover;
}
.section.sectwo {
  background-image: linear-gradient(rgba(0,0,0,0.2), rgba(0,0,0,1)), url(../assets/MoscowNight2_30.jpg);
  background-size: cover;
}
.section.secthree {
  background-image: linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.95)), url(../assets/MoscowNight3_30.jpg);
  background-size: cover;
}
.section.secone_square {
  background-image: linear-gradient(rgba(0,0,0,0.2), rgba(0,0,0,1)), url(../assets/MoscowNight1_square.jpg);
  background-size: cover;
}
.section.sectwo_square {
  background-image: linear-gradient(rgba(0,0,0,0.2), rgba(0,0,0,1)), url(../assets/MoscowNight2_square.jpg);
  background-size: cover;
}
.section.secthree_square {
  background-image: linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.9)), url(../assets/MoscowNight3_square.jpg);
  background-size: cover;
}
.theme--dark.v-expansion-panels .v-expansion-panel {
  background-color: rgba(0,0,0,0)!important; 
}
.v-expansion-panel-header { font-size:1.5em; font-weight:100; line-height:1em;}
.v-expansion-panel-header--active { font-size:1.5em; font-weight:600; line-height:1em;}
.v-expansion-panel-content { font-size:1.2em; font-weight:100; }
.v-expansion-panel:before {
    -webkit-box-shadow: unset!important;
    box-shadow: unset!important;
}
.dialogpage {
    background-color: #fff;
    opacity:.95!important;
}
.lightrow {
  background-color: rgba(0,0,0,.2);
  border-radius: 3px;
}
video {
    object-fit: fill;
}
</style>
